<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';

	interface Props {
		variant?: 'text' | 'rectangular';
		class?: string;
	}

	let { variant = 'text', ...rest }: Props = $props();
</script>

<div
	class={twMerge(
		classNames('animate-pulse bg-gray-200', {
			'h-2.5 w-full rounded-full': variant === 'text'
		}),
		rest.class
	)}
></div>
